import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mx-auto mb-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_select = _resolveComponent("app-select")!
  const _component_app_form_row = _resolveComponent("app-form-row")!
  const _component_app_button = _resolveComponent("app-button")!
  const _component_app_card = _resolveComponent("app-card")!
  const _component_app_table = _resolveComponent("app-table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_app_card, {
      label: "Function",
      classes: "pb-0"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_app_button, {
            name: "Add new item",
            icon: "fa-plus",
            theme: "info",
            to: { name: _ctx.ROUTE_NAME_AVATAR.DEFAULT.ADD }
          }, null, 8, ["to"])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_app_form_row, {
          label: "Type",
          class: "col-md-4 mx-auto"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_app_select, {
              options: _ctx.AvatarDefaultType,
              modelValue: _ctx.query.type,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.query.type) = $event)),
              onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.fetchList(0)))
            }, null, 8, ["options", "modelValue"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_app_card, null, {
      default: _withCtx(() => [
        _createVNode(_component_app_table, {
          rows: _ctx.list,
          total: _ctx.total,
          offset: _ctx.query.offset,
          limit: _ctx.query.limit,
          columns: _ctx.table.columns,
          actions: _ctx.table.actions,
          onRefreshData: _ctx.fetchList
        }, null, 8, ["rows", "total", "offset", "limit", "columns", "actions", "onRefreshData"])
      ]),
      _: 1
    })
  ], 64))
}